import * as Yup from 'yup';
import { emailRequired, numberRequired, stringRequired } from '.';

export const createTwilioSchema = Yup.object({
    account_sid: stringRequired,
    api_sid: stringRequired,
    auth_token: stringRequired,
    phone_number: stringRequired
});

export const connectSMTPSchema = Yup.object({
    smtp_host: stringRequired,
    smtp_port: numberRequired,
    imap_host: stringRequired,
    imap_port: numberRequired,
    username: stringRequired,
    password: stringRequired,
    email: emailRequired
});